/**
 * Cases Search Hook
 * Hook for PACER/Cases search functionality
 */

import { type PACERResponse } from '../../types';

import { useCourtSearch } from './useBaseCourtApi';

/**
 * Hook for Cases search functionality (PACER only, not Opinions)
 */
export const useCasesSearch = (
  initialQuery: string = '',
  exactMatch: boolean = true
) => {
  const searchHook = useCourtSearch<PACERResponse>({
    searchType: 'r',
    queryKeyPrefix: 'cases-search-v2',
    initialQuery,
    exactMatch,
  });

  return {
    pacerResults: searchHook.results,
    searchQuery: searchHook.searchQuery,
    sortOption: searchHook.sortOption,

    isSearching: searchHook.isSearching,
    isAnyLoading: searchHook.isAnyLoading,
    hasResults: searchHook.hasResults,
    hasError: searchHook.hasError,
    generalError: searchHook.generalError,
    isTokenLoading: searchHook.isTokenLoading,
    isPaginationLoading: searchHook.isPaginationLoading,

    triggerCombinedSearch: searchHook.triggerCombinedSearch,
    setSortOption: searchHook.setSortOption,
    updatePacerResults: searchHook.updateResults,
    setPaginationLoading: searchHook.setPaginationLoading,
    setSearchExecuted: searchHook.setSearchExecuted,

    error: searchHook.error,
    data: searchHook.data,
    refetch: searchHook.refetch,
  };
};
